/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag, BcsFlag } from "../unleash";

export const FcsPermissionBookingV4 = {
  show_banner_insurance_threshold: new FcsFlag.Flag(false),
  permission_booking_v4_create_manual: new FcsFlag.Flag(false),
  permission_booking_v4_create_client: new FcsFlag.Flag(false),
  permission_booking_v4_create_markeplace: new FcsFlag.Flag(false),
  permission_redirect_booking_edit_v4:  new FcsFlag.Flag(false),
  permission_redirect_booking_rj_v4:  new FcsFlag.Flag(false),
  permission_redirect_booking_duplicate_v4:  new FcsFlag.Flag(false),
  permission_booking_v3_create_markeplace: new FcsFlag.Flag(false)
};

export const BcsPermissionBookingV4 = {
  config_product_by_type_retail: new BcsFlag.JSONFlag({
    "MY": {
      "international": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "VIPPACK",
        "ONEPACK"
      ]
    },
    "ID": {
      "international": [
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "VIPPACK",
        "ONEPACK"
      ]
    }
  }),
  config_product_by_type_client: new BcsFlag.JSONFlag({
    "MY": {
      "international": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "VIPPACK",
        "ONEPACK"
      ]
    },
    "ID": {
      "international": [
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "VIPPACK",
        "ONEPACK"
      ]
    }
  }),
  config_product_by_type_shipment: new BcsFlag.JSONFlag({
    "MY": {
      "international": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "INTERPACK",
        "SAMEDAY"
      ]
    },
    "ID": {
      "international": [
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "INTERPACK",
        "SAMEDAY"
      ]
    }
  }),
  config_product_by_type_adjust: new BcsFlag.JSONFlag({
    "MY": {
      "international": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "VIPPACK",
        "ONEPACK"
      ]
    },
    "ID": {
      "international": [
        "INTERPACK",
        "INTERPACKMAXI"
      ],
      "domestic": [
        "BOSSPACK",
        "REGPACK",
        "MINIPACK",
        "JAGOPACK",
        "BIGPACK",
        "BIGPACKFAST",
        "VIPPACK",
        "ONEPACK"
      ]
    }
  }),
  config_product_by_type_rj: new BcsFlag.JSONFlag({
    "MY":[
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "VIPPACK",
      "ONEPACK",
      "INTERPACK",
      "INTERPACKMAXI"
    ],
    "ID": [
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "VIPPACK",
      "ONEPACK",
      "INTERPACK",
      "INTERPACKMAXI"
    ]
  }),
}

export const FlagsPermissionBookingV4 = {
  ...FcsPermissionBookingV4,
  ...BcsPermissionBookingV4
};

export function initFlagsPermissionBookingV4() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureBookingV4", FcsPermissionBookingV4);
  BcsFlag.register("featureBookingV4", BcsPermissionBookingV4);
}
